import React, { FC, useCallback, useMemo } from 'react';
import { Tooltip } from 'src/common';
import { useTranslation } from 'react-i18next';
import RejectButton from '../../RejectButton';
import { useCallOffsSearch, useLoadInboxEmails, useUpdateInboxEmailStatus } from 'src/models/callOffs/hooks';
import { EmailStatus } from 'src/models/callOffs/types';

interface IProps {
  selectedMailIds: string[];
  onComplete?: () => void;
  mode?: 'full' | 'short';
}

export const RejectInboxMailButton: FC<IProps> = ({ mode = 'short', ...restProps }) => {
  const { selectedMailIds, onComplete } = restProps;
  const { t } = useTranslation();

  const searchVars = useCallOffsSearch();
  const { data: callOffsData } = useLoadInboxEmails(searchVars);
  const [markAsRejected] = useUpdateInboxEmailStatus();

  const filteredIds = useMemo(() => {
    const rejectedIds = callOffsData?.callOffs.filter(_ => _.isRejected).map(_ => _.id);
    return selectedMailIds.filter(pId => !rejectedIds?.includes(pId));
  }, [callOffsData, selectedMailIds]);

  const rejectProcurements = useCallback(async () => {
    await markAsRejected(filteredIds, EmailStatus.REJECTED);
    onComplete?.();
  }, [filteredIds, markAsRejected, onComplete]);

  return (
    <Tooltip title={mode === 'full' ? undefined : t('CallOffs.rejectFromInbox')}>
      <RejectButton filteredIds={filteredIds} onReject={rejectProcurements} mode={mode} />
    </Tooltip>
  );
};
export default RejectInboxMailButton;
